import { CARE_SNAPSHOT_STEPS } from "../../../constants/careSnapshotSections";

export const PROFILE_SECTION_LABELS = {
  [CARE_SNAPSHOT_STEPS.ABOUT]: "About",
  [CARE_SNAPSHOT_STEPS.DAILY_SUPPORT]: "Daily Support",
  [CARE_SNAPSHOT_STEPS.PATTERNS_RESPONSES]: "Behavior",
  [CARE_SNAPSHOT_STEPS.GOALS_GROWTH]: "Goals & Growth",
  [CARE_SNAPSHOT_STEPS.HEALTH_CARE]: "Health & Care",
  [CARE_SNAPSHOT_STEPS.REVIEW]: "Care Story",
};

export const getProfileSectionLabel = (step) => PROFILE_SECTION_LABELS[step] || "";

export const normalizeChildCondition = (item) => {
  if (typeof item === "string") {
    return { code: "OTHER", label: item, custom: true };
  }

  return item && item.label
    ? item
    : { code: "OTHER", label: String(item), custom: true };
};

export const buildChildProfilePhotoPath = (childId, file) => {
  const rawName = String(file?.name || "").trim();
  const ext = rawName.includes(".")
    ? rawName.split(".").pop().toLowerCase()
    : "png";

  return `children/${childId}/documents/profile/photo-${Date.now()}.${ext}`;
};
